<template>
  <div class="app flex-row align-items-center">
    <vue-progress-bar></vue-progress-bar>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h2>{{ $t('forgot_password.reset_password') }}</h2>
                <div class="clearfix"></div>
                <!--<span v-show="error != null" class="text-danger">{{ error }}</span>-->
                <div class="clearfix"><br/></div>
                <b-form class="container" v-on:keydown.enter="submit">
                  <b-form-group v-bind:label="$t('forgot_password.email')" :label-cols="3" :horizontal="true">
                    <b-form-input id="email" type="email" class="form-control"
                            name="emailAddress" v-model="email" v-bind:placeholder="$t('forgot_password.email')"
                           :state="!$v.email.$invalid"
                           aria-describedby="email-feedback"/>
                    <b-form-invalid-feedback id="email-feedback">
                      {{ $t('message.required_email_filed') }}
                    </b-form-invalid-feedback>
                    <!--{{errors.email}}-->
                    <span v-if="errors.email" id="noti_email" class="xs-text-right typo-l7 xs-text-red xs-ml-auto ">
                                        <span>{{ errors.email }}</span>
                                    </span>
                  </b-form-group>
                  <b-row>
                    <b-col cols="8">
                      <b-button @click="submit" variant="dark" class="px-4" id="btn-login" :disabled="$v.email.$invalid">
                        {{ $t('forgot_password.send_password_reset_link') }}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
  .login-language {
    width: 100px;
    float: right;
    margin-top: -10px;
  }

  .login-card-body {
    padding-top: 0px !important;
    margin-top: -20px !important;
  }

  .login-logo {
    width: 85%;
    margin-bottom: 20px;
  }

  .login-copyright {
    margin-top: 40px;
    margin-bottom: -30px;
  }

  #email_input {
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  #noti_email {
    color: red;
  }

</style>

<script>
  import ChangeLanguage from '../../components/Partials/ChangeLanguages.vue'
  import {validationMixin} from 'vuelidate'
  import {required, email} from 'vuelidate/lib/validators'

  export default {
    name: 'ForgotPassword',
    components: {
      ChangeLanguage
    },
    data () {
      return {
        email: '',
        errors: {
          'email': ''
        }
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      email: {
        email,
        required
      }
    },
    methods: {
      submit: function () {
        let vm = this
        vm.errors.email = vm.$t('forgot_password.sent_email_reset_password')
        vm.axios.user.forgotPassword({'email': vm.email, 'domain': window.location.host + '/#'}, respone => {
        }, error => {
          console.log('error', error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/ForgotPassword.vue